import React from "react";
import {Link} from "react-router-dom";
import twitter from "../Assets/img/twitter.webp";
import polkta from "../Assets/img/polkta.webp";
import youtube from "../Assets/img/youtube.webp";

const Social =()=>{
    return(
        <>
         {/* Join our social icon  */}
      <section className="social-inner social-white-space">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="social-head">
                <h5>JOIN OUR SOCIAL MEDIA</h5>
                <ul>
                  <li>
                    <Link to="/">
                      <img src={twitter}></img>
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <img src={polkta}></img>
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <img src={youtube}></img>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
     
      </section>
      {/* End of our social icon  */}

        </>
    )
}

export default Social;